import { MEDIA_ORIENTATIONS } from 'js/constants';

export const detectVideosAvailability = (landscapeSource, portraitSource) => {
  const bothVideosPresent = landscapeSource && portraitSource;
  const onlyPortraitVideoPresent = !landscapeSource && portraitSource;
  const onlyLandscapeVideoPresent = !portraitSource && landscapeSource;

  return {
    bothVideosPresent,
    onlyPortraitVideoPresent,
    onlyLandscapeVideoPresent,
  };
};

export const getVideoSourceData = (landscapeSource, portraitSource) => {
  const {
    bothVideosPresent,
    onlyPortraitVideoPresent,
    onlyLandscapeVideoPresent,
  } = detectVideosAvailability(landscapeSource, portraitSource);

  const videoData = {
    mobileVideo: null,
    desktopVideo: null,
    orientation: null,
  };

  if (bothVideosPresent) {
    videoData.mobileVideo = portraitSource;
    videoData.desktopVideo = landscapeSource;
    videoData.orientation = MEDIA_ORIENTATIONS.responsive;
  } else if (onlyLandscapeVideoPresent) {
    videoData.mobileVideo = landscapeSource;
    videoData.desktopVideo = landscapeSource;
    videoData.orientation = MEDIA_ORIENTATIONS.landscape;
  } else if (onlyPortraitVideoPresent) {
    videoData.mobileVideo = portraitSource;
    videoData.desktopVideo = portraitSource;
    videoData.orientation = MEDIA_ORIENTATIONS.portrait;
  }

  return videoData;
};

export const getResponsiveVideoPreviewImageSources = ({
  landscapeSource,
  portraitSource,
  buildVideoPreviewMobilePortraitSources,
  buildVideoPreviewDesktopPortraitSources,
  buildVideoPreviewMobileLandscapeSources,
  buildVideoPreviewDesktopLandscapeSources,
}) => {
  const {
    bothVideosPresent,
    onlyPortraitVideoPresent,
    onlyLandscapeVideoPresent,
  } = detectVideosAvailability(landscapeSource, portraitSource);

  const portraitPreviewImageSrc = portraitSource?.previewImage?.src;
  const landscapePreviewImageSrc = landscapeSource?.previewImage?.src;

  if (bothVideosPresent) {
    return [
      ...buildVideoPreviewMobilePortraitSources(portraitPreviewImageSrc),
      ...buildVideoPreviewDesktopLandscapeSources(landscapePreviewImageSrc),
    ];
  } else if (onlyPortraitVideoPresent) {
    return [
      ...buildVideoPreviewMobilePortraitSources(portraitPreviewImageSrc),
      ...buildVideoPreviewDesktopPortraitSources(),
    ];
  } else if (onlyLandscapeVideoPresent) {
    return [
      ...buildVideoPreviewMobileLandscapeSources(landscapePreviewImageSrc),
      ...buildVideoPreviewDesktopLandscapeSources(landscapePreviewImageSrc),
    ];
  }
};

export const getFluidVideoPreviewImageSources = ({
  landscapeSource,
  portraitSource,
  buildVideoPreviewMobileSources,
  buildVideoPreviewDesktopSources,
}) => {
  const portraitPreviewImageSrc = portraitSource?.previewImage?.src;
  const landscapePreviewImageSrc = landscapeSource?.previewImage?.src;

  const mobileImageSrc = portraitPreviewImageSrc ?? landscapePreviewImageSrc;
  const desktopImageSrc = landscapePreviewImageSrc ?? portraitPreviewImageSrc;

  return [
    ...buildVideoPreviewMobileSources(mobileImageSrc),
    ...buildVideoPreviewDesktopSources(desktopImageSrc),
  ];
};
